import { Content } from "@/ui";
import { seo_jobs_helper } from "@/helpers/seo_jobs_helper";
import { contract_type_helper } from "@/helpers/contract_type_helper";
import { specialisms_helper } from "@/helpers/specialisms_helper";
import SeoHead from "@/components/SeoHead";

export default function Page({ content, meta }) {
  return (
    <>
      <SeoHead
        page_name={meta.title}
        canonical_link={`https://www.earthstreamglobal.com/job-role/${meta.canonical_link}`}
      />
      <Content items={content} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {

	const seo_job = seo_jobs_helper.find(url_slug);
	const contract_types = contract_type_helper.fetch();
	const disciplines = specialisms_helper.fetch();
  
  function findIdByName(contracts, contractType) {
    const contract = contracts.find(item => item.job_type === contractType);
    return contract ? contract.id : null;
  }

  const seo_contract_type = findIdByName(contract_types, seo_job.contract_type);

  function findIdsByNames(targetSpecialisms) {
    const foundIds = disciplines
        .filter(discipline => targetSpecialisms?.includes(discipline.discipline))
        .map(discipline => discipline.id);

    return foundIds || [];
  }

  const seo_specialisms = findIdsByNames(seo_job.specialisms);

  const filtered_pages = [{label: seo_job.title}]

  return {
    props: {
      meta: {
        title: seo_job.title,
        canonical_link: url_slug
      },
      content: [
        { 
          component: "BreadcrumbNavigation", 
          props: { 
            items: filtered_pages,
            className: "mt-4",
          },
        },
        {
          component: "Hero2",
          id: "Hero2",
          props: {
            label: seo_job.title,
            className: "hero-section",
          },
        },
        {
          component: "SeoJobsFeed",
          props: {
            job_id: seo_job.id,
            description: seo_job.seo_job_description ?? null,
            links: seo_job.seo_links,
            internal: !!seo_job.internal_jobs,
            contract_type_id: seo_contract_type,
            specialisms_ids: seo_specialisms
          },
        }
      ],
    },
  };
}

export async function getStaticPaths() {
  return { paths: seo_jobs_helper.toPaths(), fallback: false };
}

